export enum Point {
  HouseLocation,
  GarageLocation,
  GasStationLocation,
  GasStationViewLocation,
  ShopLocation,
  LoadLocation,
  GasStationColumnLocation,
  CleaningLocation,
  OfficeLocation,
  Spawn,
  StreetTransit,
  GarageTransit,
  LivingTransit,
  Safe,
  Wardrobe,
  Kitchen,
  Intercom,
  InteriorLocation,
  VehicleLocation,
  SignLocation,
  ExitLocation,
  ElevatorLocation,
  RoomLocation,
}
